import React, { useEffect } from "react";
import * as R from "ramda";
import { FormattedMessage } from "react-intl";
import { VStack } from "@chakra-ui/react";
import { ADDPM } from "flows/constants";
import { getFinalConfig, useSessionCtx, noop } from "utils";
import { Error } from "components/Error";
import { FraudCheck } from "components/FraudCheck";
import { Paypal } from "./Paypal";
import { CreditCard } from "./CreditCard";
import { Buttons } from "./Buttons";

const defaultConfig = {
  addCC: false,
  addPaypal: false,
};

const getPMType = R.path(["flowConfig", "pm_type"]);

// if flowConfig contains a pm_type, skip right to it, otherwise offer buttons
// based on integrator config
export const AddPMByType = ({ config, onReady = noop, onError, ...props }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onReady, []);

  const { debug, sessionCtx } = useSessionCtx();

  const pmType = getPMType(sessionCtx);
  debug("pmType: ", pmType);

  const finalConfig = getFinalConfig(ADDPM, defaultConfig, config);
  debug("finalConfig: ", finalConfig);

  switch (pmType) {
    case "cc":
      return finalConfig.addCC ? <CreditCard config={finalConfig} {...props} /> : <Error />;
    case "paypal":
      return finalConfig.addPaypal ? <Paypal config={finalConfig} {...props} /> : <Error />;
    case undefined:
      return <Buttons config={finalConfig} {...props} />;
    default:
      return (
        <Error>
          <FormattedMessage
            defaultMessage="Apologies, there was an error. Please try again."
            description="Error message"
          />
        </Error>
      );
  }
};

export const AddPM = (props) => {
  return (
    <VStack spacing="5" align="stretch">
      <FraudCheck>
        <AddPMByType {...props} />
      </FraudCheck>
    </VStack>
  );
};
